import {observer} from "mobx-react";
import {FieldAutoComplete, ModalDialog, Page, PageContentTitle} from "../../ui";
import {DialogStore, scaCustomerStore, scaDetailStore, scaZebraPrinterStore} from "../../../store";
import {useState} from "react";
import {ScaMainForm} from "./ScaMainForm";
import {ScaDocumentsForm} from "./ScaDocumentsForm";
import {convertScaStatus} from "../../../api";
import {useNavigate} from "react-router";
import {PageContentTitleAction} from "@kroschke/react-ui/dist/components/PageContentTitle";
import {AcquisitionDocumentStatusDto} from "../../../api/sca";

const ScaDetailPage = observer(function ScaDetailPage() {
    const {
        loaded,
        saving,
    } = scaDetailStore
    const [cancelDialog] = useState(new DialogStore())
    const [saveDialog] = useState(new DialogStore())
    const display = 'Sicherheitscodes erfassen'
    const status = loaded?.data.status
    const vin = loaded?.data.vin
    const customerId = loaded?.data.customerId
    const navigate = useNavigate()

    const hasInvalidCode = loaded?.data.documents.findIndex(e => e.status === AcquisitionDocumentStatusDto.CODE_INVALID) !== -1

    const actions: PageContentTitleAction[] = [
        {
            label: 'Umlagerung suchen',
            cls: 'is-info',
            action: () => {
                navigate(`/sts?q=${vin}&customerId=${customerId}&f=on`)
            }
        }
    ]

    if (hasInvalidCode) {
        actions.push({
            label: scaDetailStore.closeableWithError ? 'Abschluss mit Fehler' : 'Speichern',
            cls: `${scaDetailStore.closeableWithError ? 'is-danger' : 'is-primary'} ${saving ? 'is-loading' : ''}`,
            disabled: !(scaDetailStore.closeable) && !scaDetailStore.closeableWithError,
            action: async () => {
                await scaDetailStore.save()
            }
        })
    } else {
        actions.push({
            label: scaDetailStore.closeableWithError ? 'Abschluss mit Fehler' : 'Speichern & Einlagern',
            cls: `${scaDetailStore.closeableWithError ? 'is-danger' : 'is-primary'} ${saving ? 'is-loading' : ''}`,
            disabled: !(scaDetailStore.closeable) && !scaDetailStore.closeableWithError,
            action: async () => {
                saveDialog.dialogOpen = true
                await scaZebraPrinterStore.load()
            }
        })
    }

    actions.push({
        label: 'Verwerfen',
        cls: 'is-primary is-outlined',
        disabled: true,
        action: async () => {
            cancelDialog.dialogOpen = true
        }
    })


    return <Page
        breadcrumb={[
            {
                link: '/sca',
                label: `Sicherheitscodes`
            },
            {
                link: `/sca/${scaDetailStore.id}`,
                label: display
            }
        ]}
    >
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        await scaDetailStore.reset()
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Änderungen verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
        </ModalDialog>
        <ModalDialog store={saveDialog} titleCloseable={false} actions={[
            {
                label: "Abbrechen",
                execute: async function () {
                    saveDialog.dialogOpen = false
                },
                className: 'is-rounded is-small'
            },
            {
                label: "Speichern & Einlagern",
                execute: async function () {
                    if (!scaDetailStore.printer?.id) {
                        return
                    }
                    saveDialog.executing = true
                    const r = await scaDetailStore.save()
                    if (!r) {
                        return
                    }
                    saveDialog.executing = false
                    saveDialog.dialogOpen = false
                },
                className: 'is-rounded is-small is-primary'
            }
        ]}>
            <FieldAutoComplete
                label={"Labeldrucker"}
                help={"Bitte wähle den zu verwendenden Drucker"}
                required={true}
                itemRenderer={c => c.label}
                options={scaZebraPrinterStore.options}
                search={async (v) => {
                    await scaZebraPrinterStore.find(v)
                    return scaZebraPrinterStore.options
                }}
                value={scaDetailStore.printer}
                onChange={v => {
                    scaDetailStore.printer = v
                }}
            />
        </ModalDialog>
        <PageContentTitle
            actions={actions}
        >{display} {status ? `[${convertScaStatus(status)}]` : ''}</PageContentTitle>
        <ScaMainForm
            disabled={true}
            customers={scaCustomerStore.items}
            validation={{}}
            value={scaDetailStore.formData}
            onChange={() => {
            }}
            onBlur={() => {
            }}
            onSearchCustomer={async () => []}
        />
        <ScaDocumentsForm
            disabled={scaDetailStore.disabled}
            customers={scaCustomerStore.items}
            validation={scaDetailStore.formValidation}
            value={scaDetailStore.formData}
            onChange={v => scaDetailStore.formData = v}
            onBlur={async () => await scaDetailStore.validate()}
            onSearchCustomer={async () => []}
        />
    </Page>
})

export {
    ScaDetailPage
}
